/**
 * RadioGroup
 * 
 * @Author: Focci
 * @Date: 2023-08-10 10:24:08
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-10 10:24:08
 */

import PropTypes from 'prop-types'
import { Radio, RadioGroup, FormControlLabel } from '@comp/material'

export default function GroupedRadio({
  options = [], // [{ label: '', value: '' }, ...]
  ...radioProps
}) {
  return (
    <RadioGroup
      sx={{ 
        '&.MuiFormGroup-root': { 
          flexWrap: 'nowrap',
          flexDirection: 'row'
        } 
      }} 
      {...radioProps}
    >
      {options.map((option) => (
        <FormControlLabel 
          key={option.value} 
          value={option.value} 
          label={option.label} 
          control={<Radio />}
          sx={{ 
            '& .MuiTypography-root': { 
              whiteSpace: 'nowrap',
            } 
          }}  
        />
      ))}
    </RadioGroup>
  )
}

GroupedRadio.propTypes = {
  options: PropTypes.array,
}
